module.exports = __webpack_public_path__ + "img/drone_01_H.691bac81.webp";